<template>
	<div class="modal fade" v-if="data" id="mdClientes" data-backdrop="static">
		<div class="modal-dialog modal-lg">
			<div class="modal-content">
				<div class="modal-header">
					<h4 class="modal-title">Clientes</h4>
				</div>

				<div class="modal-body">
					<identification
						:dIn="data"
						ref="Identification"
						:disabled="disabled == false"
					/>
					<ul
						class="nav nav-tabs"
						v-if="this.data.tipo_de_cliente !== 7"
					>
						<li
							@click="active = 'info'"
							:class="{ active: active == 'info' }"
						>
							<a>Informações</a>
						</li>
						<li
							@click="active = 'contatos'"
							:class="{ active: active == 'contatos' }"
						>
							<a>Contatos</a>
						</li>
						<li
							@click="active = 'rl'"
							:class="{ active: active == 'rl' }"
						>
							<a>Representate legal</a>
						</li>

						<li
							class="pull-right"
							@click="new_rp"
							v-if="active != 'info'"
						>
							<a><i class="fa fa-plus"></i></a>
						</li>
					</ul>
					<div
						class="tab-content"
						v-if="this.data.tipo_de_cliente !== 7"
					>
						<informations
							v-if="active == 'info'"
							:dIn="data"
							:disabled="disabled == false"
						/>
						<contacts
							v-else-if="active == 'contatos'"
							:disabled="disabled == false"
							:dIn="data"
							@remove="remove_rp"
						/>
						<representante
							:disabled="disabled == false"
							@remove="remove_rp"
							ref="rp"
							v-else-if="active == 'rl'"
							:dIn="data"
						/>
					</div>
					<div class="clearfix"></div>
				</div>
				<div class="modal-footer">
					<button
						type="button"
						class="btn btn-default"
						data-dismiss="modal"
						@click="closeModal"
					>
						<i class="fa fa-close"></i> Cancelar
					</button>
					<aBtn
						v-if="!(disabled == false)"
						action="private-save-customers"
						@click="save"
						text="Salvar"
						icon="save"
						type="primary"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import { reset, reset_representante } from './reset.js';
	import clone from 'js/clone';
	import aBtn from 'btn';
	import toastr from 'toastr';
	import WBS from 'js/http';

	//Componentes
	import informations from './components/informations.vue';
	import identification from './components/identification.vue';
	import representante from './components/represent_legal.vue';
	import contacts from './components/contacts.vue';

	export default {
		name: 'MdClientes',
		components: {
			informations,
			identification,
			representante,
			aBtn,
			contacts,
		},
		props: {
			disabled: {
				default: true,
			},
		},
		data() {
			return {
				active: 'info',
				data: clone(reset),
			};
		},
		methods: {
			remove_rp(id) {
				if (this.active == 'rl') this.data.representates.splice(id, 1);
				else this.data.contatos.splice(id, 1);
			},
			new_rp() {
				if (this.active == 'rl')
					this.data.representates.push(clone(reset_representante));
				else this.data.contatos.push({ name: '', mail: '', tels: '' });
			},
			open(data = null) {
				this.closeModal();
				this.$nextTick(() => {
					let loadData = data ? clone(data) : clone(reset);
					loadData.contatos = loadData.contatos || [];
					this.data = loadData;
					this.$nextTick(() => {
						$('#mdClientes').modal('show');
						console.log(
							'Modal de Cliente aberto com dados:',
							loadData
						);
					});
				});
			},
			closeModal() {
				$('#mdClientes').modal('hide');
				this.resetModal();
			},
			resetModal() {
				this.data = clone(reset);
			},
			save() {
				console.log(this.data.tipo_de_cliente);

				if (this.data.cnpj == '' && this.data.tipo_de_cliente !== 7) {
					toastr.warning('Preencha o cnpj!');
				} else if (
					this.data.tipo_de_cliente == 7 &&
					this.data.razao_social == ''
				) {
					toastr.warning('Insira a Razão Social');
				} else if (!this.$refs.Identification.is_valid()) {
					toastr.warning('Preencha os dados corretamente');
				} else {
					WBS.send('private-save-customers', this.data, (resp) => {
						// console.log(resp)
						if (resp.status == 'success') {
							toastr.success('Registro alterado com sucesso!');
							this.$emit('update', resp.data);
							$('#mdClientes').modal('hide');
						} else {
							toastr.error(resp.msgs[0]);
							console.log(resp);
						}
					});
				}
			},
		},
	};
</script>
<style scoped>
	.nav-tabs li a {
		height: 41px;
		cursor: pointer;
	}
</style>



// WEBPACK FOOTER //
// src/components/cadastros/customers/modal.vue